module.exports = __webpack_public_path__ + "static/img/easy-to-create-organizational-chart.8dc9d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/easy-to-create-organizational-chart.png
// module id = uHHB
// module chunks = 0